/* eslint-disable no-extra-boolean-cast */
import { Grid, Switch } from "@mui/material";
import MDBox from "components/Basics/MDBox";

const InputBoolean = ({ label, value, onChange, disabled, error, InputProps = {}, ...rest }) => {
	return (
		<Grid
			size="grow"
			sx={{
				flexBasis: "16.666%",
				minWidth: "16.666%"
			}}
		>
			<MDBox
				display="flex"
				justifyContent="space-between"
				alignItems="center"
				className="customSwitchContainer"
				onClick={e => {
					onChange(!Boolean(value));
				}}
				{...InputProps}
			>
				<span>{label}</span>
				<MDBox>
					<Switch disabled={disabled} checked={Boolean(value)} />
				</MDBox>
			</MDBox>
		</Grid>
	);
};
export default InputBoolean;
